import { CashOutModalSchema } from '@/views/account/MyBets/Components/MyBetsCard/components/CashOutModal/styles/CashOutModal.styles';

export const cashOutModalStyles: CashOutModalSchema = {
  modalContent: {
    bg: 'alpha.700',
    borderRadius: 'lg',
    boxShadow:
      '0px 0px 0px 2px #FFC033 inset, 0px 0px 0px 3px rgba(255, 255, 255, 0.6) inset, 0px 0px 0px 3px #751410 inset, 0px 6px 10px 0px rgba(0, 0, 0, 0.2)',
    sx: {
      '.chakra-modal__close-btn': {
        color: 'gamma.600',
      },
    },
  },
  stackWrapper: {
    bg: 'blackAlpha.400',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
  },
  heading: { color: 'gamma.200' },
  moneyValues: { color: 'gamma.600' },
  cashedOutText: {},
  cashedOutQuestion: { color: 'gamma.200' },
  declineButton: {
    variant: 'outline',
    fontWeight: 'normal',
    lineHeight: 'normal',
    py: '5',
  },
  acceptButton: {
    variant: 'solid',
    fontWeight: 'normal',
    lineHeight: 'normal',
    h: '44px',
    py: 'unset',
  },
  doneButton: {},
};
